import { render, staticRenderFns } from "./DogumTarihiGuncelleme.vue?vue&type=template&id=be3f7f1c&scoped=true"
import script from "./DogumTarihiGuncelleme.vue?vue&type=script&lang=js"
export * from "./DogumTarihiGuncelleme.vue?vue&type=script&lang=js"
import style0 from "./DogumTarihiGuncelleme.vue?vue&type=style&index=0&id=be3f7f1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be3f7f1c",
  null
  
)

export default component.exports